import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/duplicate.svg
 */
const IconDuplicate: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M19.312 22.967a1 1 0 01-.301.732 1.013 1.013 0 01-.734.3H3.785a1.016 1.016 0 01-.734-.3.997.997 0 01-.3-.732V2.968a1 1 0 01.3-.732 1.013 1.013 0 01.734-.303h4.027v15.975a1.035 1.035 0 00.302.734 1.031 1.031 0 00.732.3h10.466v4.025z"
      fill="currentColor"
    />
    <path
      d="M21.248 17.003H10.783a1.028 1.028 0 01-.959-.635 1.027 1.027 0 01-.076-.397V0h4.6v5.859a1.036 1.036 0 001.035 1.034h5.865v10.11z"
      fill="currentColor"
    />
    <path
      d="M21.25 5.514h-5.52V0h.258a.996.996 0 01.734.301l4.226 4.222a1 1 0 01.302.732v.259z"
      fill="currentColor"
    />
  </svg>
);

export default IconDuplicate;
